const stepNameList = {
  1: 'Select an option to either request an investigation or report a failure',
  2: 'Select a facility asset or network equipment for Request an Investigation',
  3: 'Enter equipment details',
  4: 'Enter action item details',
};

export const getStepName = (t, stepNumber, aiOption) => {
  let stepName = stepNameList[stepNumber];

  if (+stepNumber === 2 && aiOption === 'reportFailure') {
    stepName = 'Select a facility asset or network equipment for Report a Failure';
  }

  if (+stepNumber === 3 && aiOption === 'reportFailure') {
    stepName = 'Enter Equipment / Sensor details';
  }

  return `${t('step')} ${stepNumber}: ${t(stepName)}`;
};
